import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { fireTrackAnalytics } from '@atlassian/jira-analytics-web-react/src/utils/fire-track-event.tsx';
import { fireCustomErrorAnalytics } from '@atlassian/jira-servicedesk-knowledge-common/src/common/utils';
import { updateCategoriesForArticle } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/articles/index.tsx';
import {
	UPDATE_CATEGORIES_FOR_ARTICLE,
	type UpdateCategoriesForArticleAction,
} from '../../state/actions/update-categories-for-article';
import { updateCategoriesForArticleFailure } from '../../state/actions/update-categories-for-article-failure';
import { updateCategoriesForArticleSuccess } from '../../state/actions/update-categories-for-article-success';
import { getCategoriesForArticle } from '../../state/selectors/articles';
import { getActivationId, getProjectId } from '../../state/selectors/base';
import type { State } from '../../state/types';
import { PACKAGE_NAME } from '../../view/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$
		.ofType(UPDATE_CATEGORIES_FOR_ARTICLE)
		.mergeMap((action: UpdateCategoriesForArticleAction) => {
			const { categoryIds, articleId, analyticsEvent, spaceKey } = action.payload;
			const projectId = getProjectId(store.getState());
			const activationId = getActivationId(store.getState());
			const currentCategoryIds = getCategoriesForArticle(store.getState(), articleId).map(
				(category) => category.id,
			);

			return updateCategoriesForArticle({
				projectId,
				categoryIds,
				articleId,
				spaceKey,
				activationId,
			})
				.map(() => {
					fireTrackAnalytics(analyticsEvent, {
						action: 'update',
						actionSubjectId: articleId,
					});

					return updateCategoriesForArticleSuccess({
						articleId,
						categoryIds,
						previousCategoryIds: currentCategoryIds,
					});
				})
				.catch((error) => {
					const { statusCode, errorKey, errorMessage, categories } = error;
					fireCustomErrorAnalytics({
						error,
						event: analyticsEvent,
						id: 'articleUpdate Failure',
						packageName: PACKAGE_NAME,
					});
					return Observable.of(
						updateCategoriesForArticleFailure({
							statusCode,
							errorKey,
							errorMessage,
							failedCategoryIds: categories,
							articleId,
						}),
					);
				});
		});
